export default {
    DEMANDA_ESPONTANEA: 1,
    PROGRAMADA: 2
}